import Header from '../components/header';
import Footer from '../components/footer';
import Section3 from '../components/section3';
import Loading3 from '../components/loading3';
import { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';


const Home = () => {
    document.title = "Voice Coach in Sydney for Podcast | Voicecoach.net";
    const [data, setData] = useState({});
    const popup = useRef();
    const leadcollect = useRef();
    const myname = useRef();
    const popcontent = useRef();
    const [loading, setLoading] = useState(true);
    const sendebook = () => {
        leadcollect.current.classList.remove('is-invalid');
        let email = leadcollect.current.value;
        if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(email)) {
            return leadcollect.current.classList.add('is-invalid');
        }
        if (window.localStorage.getItem('sentebook') === null) {
            let formData = {}; formData._e = window.btoa(email); formData.__e = window.btoa(myname.current.value);
            window.localStorage.setItem('closepopup', 1);window.localStorage.setItem('sentebook', 1);
            fetch('https://api.voicecoach.net/collect', {method: 'POST', keepalive: true, body: JSON.stringify(formData), headers: {"Content-Type": "application/json"}})
            .then(_ => _.json());
        }
        popcontent.current.innerHTML = '<div class="col-12 col-lg-4"><svg version="1.1" x="0px" y="0px" class="w-100" viewBox="0 0 98.5 98.5" enableBackground="new 0 0 98.5 98.5"><path class="checkmark" fill="none" strokeWidth="8" strokeMiterlimit="10" d="M81.7,17.8C73.5,9.3,62,4,49.2,4C24.3,4,4,24.3,4,49.2s20.3,45.2,45.2,45.2s45.2-20.3,45.2-45.2c0-8.6-2.4-16.6-6.5-23.4l0,0L45.6,68.2L24.7,47.3"/></svg></div>'+
        '<div class="col-lg-8 col-12"><h3 class="display-4 mt-4">Your eBook has been delivered!<h3></div>';
        setTimeout(() => { popup.current.remove() }, 3500);
    }
    const closelead = () => {popup.current.classList.add('d-none'); window.localStorage.setItem('closepopup', 1); }
    useEffect(() => {
        setTimeout(() => {
            if (window.localStorage.getItem('closepopup') === null) {   
                popup.current.classList.remove('d-none');
            }
        }, 7000);
        fetch('https://api.voicecoach.net/home')
        .then(response => response.json())
        .then(data => {setData(data); setLoading(false); })
    }, []);
        return (<>
    <Header />
    <main>
    <section className="text-bg-vc">
    <div className="container pt-5">
        <div className="row flex-column-reverse flex-lg-row">
            <div className="col-lg-4 col-12">
                <div className="text-center tagline">
                        <h2 data-aos="zoom-in">Power-up Your Podcast!</h2>
                        <h3 data-aos="zoom-in">Get your voice heard across the globe.</h3>
                </div>
            </div>
            <div className="col-lg-8 col-12">
            <img src="/img/voice-coaching.svg" alt="Voice Coaching Sydney" className="w-100" />
            </div>
        </div>
        </div>
    </section>
    <section className="text-bg-vc-white container">
        <div className="row">
            <div className="col-lg-6" data-aos="fade-up-left" data-aos-duration="1000">
                <img src="/img/voice-coaching-sydney.svg" alt="Podcast training Sydney" className="w-100" />
            </div>
            <div className="col-lg-6 tagline" data-aos="fade-up-right" data-aos-duration="1000">
                <p className="mt-5"><span className="highlight">Become a star</span> by recording your own podcast and sharing your views with the world.</p>
            </div>
            <div className="col-lg-6 tagline" data-aos="fade-down" data-aos-duration="1000">
                <p>The Voice Coach will teach you how to <span className="highlight">organize your thoughts, write a script, and deliver it like a <span className="imp">pro!</span></span></p>
            </div><div className="col-lg-6" data-aos="fade-down" data-aos-duration="1000">
<img src="/img/coach-help.svg" alt="Learn how to podcast" className="w-100" />
            </div>
            <div className="col-lg-6" data-aos="fade-down" data-aos-duration="1000">
                <img src="/img/voice-coach-software.svg" className="w-100" alt="Setup Podcast Studio" />
            </div>
            <div className="col-lg-6" data-aos="zoom-in" data-aos-duration="1000">
                <p className="tagline"><span className="imp pb-12">We've got your back!</span></p>
                <p className="tagline">You'll learn how to set up a <span className="highlight">recording studio on your laptop</span> using great software and your computer.</p>
            </div>
            </div>
    </section>
    <section className="wording text-bg-vc mt-5 pb-5">
        <div className="container">
            <div className="row">
                {loading ? <Loading3 /> : <Section3 data={data} />}
            </div>
        </div>
    </section>
    <section>
        <div className="container">
            <div className="row my-5">
                <div className="col-lg-12" data-aos="zoom-in">
                    <p className="text-center">
                        <Link to="/about-you" className="btn big-button btn-primary">is this you?</Link>
                    </p>
                </div>
        </div>
        </div>
        <div ref={popup} className="popup-lead d-none">
            <div className="popup-content row" ref={popcontent}>
                <div className='position-relative'>
                <div className='position-absolute end-0 top-0 text-white px-2 bg-danger' style={{cursor:'pointer'}} onClick={closelead}>x</div>
                </div>
                    <div className="col-12 col-lg-6">
                        <img src="/img/podcasting-cover.jpg" className="w-100" alt="Free Podcast eBook" />
                    </div>
                    <div className="col-12 col-lg-6 mt-3">
                        <div className='d-none d-lg-block my-3'>&nbsp;</div>
                        <div>
                        <h3 className="bg-warning p-3">Grab your Free eBook</h3>
                        <h3 className="bg-info p-2 m-2 d-inline">Podcasting 101</h3>
                        <h3 className='bg-primary text-white p-3'>By The Voice Coach</h3>
                        </div>
                        <div className='row'>
                            <div className='col-12 col-lg-6'>
                        <div className='mt-1 form-group px-3'>
                            <input type="text" ref={myname} name="_" placeholder='Enter your name' className='collect form-control mb-2' />
                        <input type="text" ref={leadcollect} name="__" placeholder='Enter your email address' className='collect form-control' aria-describedby='validationFeedback' />
                        <div id="validationFeedback" className="invalid-feedback">Please enter a valid email address.</div>
                        </div></div>
                        <div className='col-12 col-lg-6'>
                        <div className="mt-3"><button className='btn btn-primary btn-lg' onClick={sendebook}>Mail me the eBook</button>
                        <button className='btn btn-white' onClick={closelead}>Not now, Thanks</button>
                        </div>
                        </div>
                        </div>
                    </div>
            </div>
        </div>
    </section>
</main>
    <Footer />
    </>)
}
export default Home;
